export default {
  loginTitle: "LanguageHunt",
  platformDescription: "a language learning platform.",
};
